import { localeFromPath, stripLocale, withLocale } from './localePath';

/** Smooth-scroll to a section, accounting for the fixed header. */
export function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  const locale = localeFromPath(window.location.pathname);
  history.replaceState(null, '', `${withLocale(locale, '/')}#${id}`);
}

/**
 * Navigate to a homepage section from any route.
 * Uses locale-prefixed `/fr#id` (etc.) when not already on home.
 */
export function goToSection(
  id: string,
  navigate: (to: string) => void,
  pathname: string
) {
  const locale = localeFromPath(pathname);
  const bare = stripLocale(pathname);
  if (bare === '/' || bare === '') {
    scrollToId(id);
    return;
  }
  navigate(`${withLocale(locale, '/')}#${id}`);
}
